// @ts-nocheck
import React from "react";
import {TextFieldRojo} from "../App";

export default function FormInputMultiline(props){

    const {name, label, value, errorText, onChange, ...otherProps} = props;
    return (
        <TextFieldRojo
            multiline
            minRows={4}
            variant="outlined"
            name={name}
            helperText={errorText}
            label={label}
            value={value}
            onChange={onChange}
            {...otherProps}
        />
    )
}